import { useCallback } from 'react';

import { useTranslate } from '@dreryk/react-common';

import { practitionersTranslationKeys } from '../../../../../translations';

import { DefaultConfidentialityModeOption } from './DefaultConfidentialityModeCell.types';

export const useTriggerLabelExtractor = (): ((item: DefaultConfidentialityModeOption) => string) => {
   const translate = useTranslate();

   return useCallback(
      (item: DefaultConfidentialityModeOption): string => translate(practitionersTranslationKeys.defaultDataMode[item]),
      [translate]
   );
};
